import { render } from "./FamilyDescriptionCard.vue?vue&type=template&id=7496acfc&scoped=true"
import script from "./FamilyDescriptionCard.vue?vue&type=script&lang=js"
export * from "./FamilyDescriptionCard.vue?vue&type=script&lang=js"

import "./FamilyDescriptionCard.vue?vue&type=style&index=0&id=7496acfc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7496acfc"]])

export default __exports__